module.exports = __webpack_public_path__ + "static/4-1669fdf68afdef6659a5ae73fd55f506.jpeg";